import { createButton, parseButtonsPositions } from '@/utils/buttons'
import { defaultList } from '@/conf/buttons'
import i18n from '@/utils/i18n'

export function getListButtons (entityName, onlyShow, buttons, id = null, entity = null) {
  if (buttons === undefined || onlyShow) {
    return {}
  } else if (buttons.default) {
    return parseButtonsPositions(defaultList, entityName, onlyShow, id, entity)
  } else if (buttons.definition) {
    return parseButtonsPositions(buttons.definition, entityName, onlyShow, id, entity)
  } else {
    return {}
  }
}

export function getListActions (entityName, actions, onlyShow, id, entity = null, allowed = []) {

  let ret = []
  let buttons = []
  let defaultActions = ['show', 'edit']

  if (actions === undefined) {
    return ret
  } else if (actions.default) {
    buttons = defaultActions
  } else {
    if (onlyShow) {
      if (allowed.length) {
        for (let [key, val] of Object.entries(actions)) {
          if (val && allowed.includes(key)) {
            buttons.push(key)
          }
        }
      }

      if (!buttons.includes('show')) buttons.push('show')
    } else {
      for (let [key, val] of Object.entries(actions)) {
        if (val) buttons.push(key)
      }
    }
  }

  for (let action of buttons) {
    let button = createButton(action, entityName, id, false, true, true, entity)
    if (button) {
      ret.push(button)
    }
  }

  return ret
}

/**
 * Create vuetable field definitions
 *
 * @param translationPrefix string for translation prefix
 * @param listFields array of list fields
 * @param entityFields array of entity fields
 * @param actions bool to enable or disable actions column
 * @returns {Array} vuetable field definition
 */
export function createVueTableFields (translationPrefix, listFields, entityFields, actions = false) {
  let tableFields = []
  let defaultFieldType = 'text'

  for (let listField of listFields) {
    for (let field of entityFields) {
      if (field.name === listField) {
        let type = field.type || defaultFieldType
        let callback
        let translatedTitle = translationPrefix + '.' + field.name
        let title = i18n.te(translatedTitle) ? i18n.t(translatedTitle) : i18n.tc('_' + field.name, 1)

        switch (type) {
          case 'boolean':
            callback = 'formatBool'
            break
          case 'category':
            callback = 'formatCategory'
            break
          case 'date':
            callback = 'formatDate'
            break
          case 'dateWithDay':
            callback = 'formatDateWithDay'
            break
          case 'dateTime':
            callback = 'formatDateTime'
            break
          case 'email':
            callback = 'formatEmail'
            break
          case 'fullName':
            callback = 'fullName'
            break
          case 'image':
            callback = 'formatImage'
            break
          case 'number':
            callback = 'formatNumber'
            break
          case 'object':
            // Cela nous permet de passer le paramètre entityName à la fonction
            callback = 'linkToShowSheet|' + field.entityName
            field.sortable = false
            break
          case 'array':
            callback = 'formatArray'
            field.sortable = true
            break
          case 'phoneNumber':
            callback = 'formatPhoneNumber'
            break
          case 'role':
            callback = 'formatRole'
            break
          case 'status':
            callback = 'translateStatus'
            break
          case 'text':
            if (field.translate) {
              callback = 'translateConst'
            }
            break
          case 'hidden':
            callback = 'formatHiddenText'
            break
          case 'field_type':
            if (field.translate) {
              callback = 'formatFieldType'
            }
            break
          case 'url':
            callback = 'formatUrl'
            break
          default:
            throw new Error(field.type + ' is not part of accepted list types')
        }

        let tempField = {
          name: field.name,
          callback: callback,
          title: title
        }

        if (field.sortable === undefined || field.sortable === true) {
          tempField.sortField = field.name
        }

        tableFields.push(tempField)
      }
    }
  }

  if (actions) {
    tableFields.push({
      name: '__slot:list-actions'
    })
  }

  return tableFields
}

export function getCssConfig () {
  return {
    table: {
      tableClass: 'table table-striped table-hover table-responsive-lg',
      loadingClass: 'vuetable-loading',
      // ascendingIcon: 'glyphicon glyphicon-chevron-up',
      // descendingIcon: 'glyphicon glyphicon-chevron-down',
      // handleIcon: 'glyphicon glyphicon-menu-hamburger',
      ascendingIcon: 'fas fa-arrow-down',
      descendingIcon: 'fas fa-arrow-up',
      handleIcon: 'fas fa-bars',
      sortableIcon: '', // fas fa-sort-amount-up',  // since v1.7
      ascendingClass: 'sorted-asc', // since v1.7
      descendingClass: 'sorted-desc' // since v1.7
      /*
      renderIcon: function () {
        return `<span class="fa fa-sort float-right"></span>`
      }
      */
    },
    pagination: {
      wrapperClass: 'pagination float-right',
      activeClass: 'active',
      disabledClass: 'disabled',
      pageClass: 'btn btn-default page-item',
      linkClass: 'btn btn-default page-link',
      paginationClass: 'pagination',
      paginationInfoClass: 'float-left',
      dropdownClass: 'form-control',
      icons: {
        first: '',
        prev: '',
        next: '',
        last: ''
      }
    }
  }
}
